import { ActionActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const ActionReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case ActionActionType.Action_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default ActionReducer
